<template>
	<v-autocomplete dense outlined :item-value="'id'" :item-text="'title'" v-model="localValue" :items="localFeatureTypes">
		<template v-slot:item="data">
			<div class="display-flex flex-row flex-align-center item-container py-2">
				<div class="item-name first-letter-uppercase">
					{{ data.item.title }}
				</div>
			</div>
		</template>
	</v-autocomplete>
</template>
<script>
import { FlowType } from '@ply-io/ply-front-shared-utilities';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { useMarketplaceFilterByFeatureType } from '@/store/modules/marketplace/getters';
import { setMarketplaceFilterByFeatureType } from '@/store/modules/marketplace/actions';
export default {
	name: 'MarketplaceFeatureTypeDropdown',
	computed: {
		...mapGettersShorthand({ useMarketplaceFilterByFeatureType }),
		localValue: {
			get() {
				return this.localFeatureTypes.find((item) => item.id === this.useMarketplaceFilterByFeatureType);
			},
			set(value) {
				const doesValueExist = this.localFeatureTypes.find((item) => item.id === value);
				if (doesValueExist) {
					this.setMarketplaceFilterByFeatureType({ marketplaceFilterByFeatureType: value });
				}
			},
		},
	},
	methods: {
		...mapActionsShorthand({ setMarketplaceFilterByFeatureType }),
	},
	data() {
		return {
			localFeatureTypes: [
				{ id: 'everything', title: 'All feature types' },
				{ id: FlowType.Experience, title: 'Add-on' },
				{ id: FlowType.Tool, title: 'Tool' },
			],
		};
	},
	watch: {},
};
</script>
<style lang="scss" scoped></style>
